import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, Tabs, Tab, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import Switch from "@mui/material/Switch";
import { useNavigate,useLocation } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import {FONT_FAMILY, SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { getLangKey } from "common/src/other/getLangKey";
import BlockIcon from '@mui/icons-material/Block';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const { updateUserCar, editCar} = api;
  const [driversObj, setDriversObj] = useState();
  const [data, setData] = useState([]);
  const carlistdata = useSelector((state) => state.carlistdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const [tabValue, setTabValue] = useState(0);
  const [declineDialogOpen, setDeclineDialogOpen] = useState(false);
  const [declineReason, setDeclineReason] = useState('');
  const [selectedCarToDecline, setSelectedCarToDecline] = useState(null);

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {}; 
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        obj[user.id] = `${user.firstName} ${user.lastName} (${
          settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")
        }) ${settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")}`;
      }
      setDriversObj(obj);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
    t,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata?.cars && driversObj) { 
      const updatedData = carlistdata.cars.map((car) => ({
        ...car,
        driverName: driversObj[car?.driver] || " ",  
      }));
      setData(updatedData);
    } else {
      setData([]);
    }
  }, [carlistdata?.cars, driversObj]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getFilteredData = () => {
    if (tabValue === 0) {
      return data.filter(car => car.approved === true && car.declined !== true);
    } else if (tabValue === 1) {
      return data.filter(car => (car.approved === false || car.approved === undefined) && car.declined !== true);
    } else {
      return data.filter(car => car.declined === true);
    }
  };

  const handleDeclineClick = (rowData) => {
    if (settings.AllowCriticalEditsAdmin && role === "admin") {
      setSelectedCarToDecline(rowData);
      setDeclineDialogOpen(true);
    } else {
      setCommonAlert({ open: true, msg: t('demo_mode')});
    }
  };

  const handleDeclineConfirm = async () => {
    if (!declineReason.trim()) {
      setCommonAlert({ open: true, msg: t('decline_reason_required') || 'Decline reason is required'});
      return;
    }

    const carData = {
      ...selectedCarToDecline,
      approved: false,
      declined: true,
      declineReason: declineReason,
      declinedAt: new Date().toISOString(),
      active: false
    };

    dispatch(editCar(carData, "Decline"));
    
    if (selectedCarToDecline.driver) {
      dispatch(
        updateUserCar(selectedCarToDecline.driver, {
          carApproved: false,
          carType: null,
          vehicleNumber: null,
          vehicleMake: null,
          vehicleModel: null,
          other_info: null,
          car_image: null,
          updateAt: new Date().getTime()
        })
      );
    }

    setDeclineDialogOpen(false);
    setDeclineReason('');
    setSelectedCarToDecline(null);
  };

  const handleDeclineCancel = () => {
    setDeclineDialogOpen(false);
    setDeclineReason('');
    setSelectedCarToDecline(null);
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if(settings.AllowCriticalEditsAdmin){
    if (selectedImage) {
      setLoading(true);
      let finalData = userData;
      finalData.car_image = selectedImage;
      dispatch(editCar(finalData, "UpdateImage"));
      setProfileModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
    
  }else{
    setCommonAlert({ open: true, msg: t('demo_mode')})
  }
}

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };

  const getColumns = () => {
    const baseColumns = [
      {
        title: t("createdAt"),
        field: "createdAt",
        editable: "never",
        defaultSort: "desc",
        render: (rowData) =>
          rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      },
      {
        title: t("driver"),
        field: "driverName",  
        editable: role === "driver" ? "never" : "always",
        render: (rowData) => rowData.driverName || null,
        exportTransformer: (rowData) => rowData.driverName,
        hidden: role === "driver",
      },
      { title: t("car_type"), field: "carType",
        render: (rowData) =>
          rowData.createdAt ? t(getLangKey(rowData.carType)) : null,
      },
      { title: t("vehicle_reg_no"), field: "vehicleNumber" },
      { title: t("vehicle_model_name"), field: "vehicleMake" },
      { title: t("vehicle_model_no"), field: "vehicleModel" },
      { title: t("other_info"), field: "other_info" },
      {
        title: t("image"),
        field: "car_image",
        initialEditValue:
          "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
        render: (rowData) =>
          rowData.car_image ? (
            <button
              onClick={() => {
                onClick(rowData);
              }}
            >
              <img alt="CarImage" src={rowData.car_image} style={{ width: 50 }} />
            </button>
          ) : null,
      },
      {
        title: t("active_status"),
        field: "active",
        editable:  "never" ,
        type: "boolean",
        initialEditValue: true,
        hidden: tabValue === 2,
        render: (rowData) => (
          <Switch
            checked={rowData.active}
            onChange={() => handelActiveStatus(rowData)}
            disabled={!(role === "admin" || role === "driver")}
          />
        ),
      },
      {
        title: t("approved"),
        field: "approved",
        editable: role === "admin" ? "never" : "always",
        type: "boolean",
        initialEditValue: true,
        hidden: tabValue === 2,
        render: (rowData) => (
          <Switch
            checked={rowData.approved}
            onChange={() => handelApproved(rowData)}
            disabled={!(settings.AllowCriticalEditsAdmin && settings.carApproval && role === "admin")}
          />
        ),
      },
    ];

    if (tabValue === 2) {
      baseColumns.push({
        title: t("decline_reason"),
        field: "declineReason",
        editable: "never",
        render: (rowData) => rowData.declineReason || "-",
      });
    }

    return baseColumns;
  };
  const [selectedRow, setSelectedRow] = useState(null);
  const handelApproved = (rowData) => {

    if (settings.carApproval && role === "admin" && settings.AllowCriticalEditsAdmin) {
      const newApprovedStatus = !rowData.approved;

      // Update the car's approved status in Firebase
      dispatch(editCar({ ...rowData, approved: newApprovedStatus }, "Update"));

      // Update the user's carApproved status if this car is active
      if (rowData.active) {
        dispatch(
          updateUserCar(rowData.driver, {
            carApproved: newApprovedStatus,
            updateAt: new Date().getTime()
          })
        );
      }
    }
  };
  const handelActiveStatus = (rowData) => {
    if (role === "admin" || role === "driver") {
      const newActiveStatus = !rowData.active;

      // If setting this car as active, deactivate all other cars for the same driver
      if (newActiveStatus && rowData.driver) {
        // Find and deactivate other active cars for this driver
        carlistdata.cars.forEach((car) => {
          if (car.driver === rowData.driver && car.active && car.id !== rowData.id) {
            dispatch(editCar({ ...car, active: false }, "Update"));
          }
        });
      }

      // Update the current car's active status
      const updateData = { ...rowData, active: newActiveStatus };
      dispatch(editCar(updateData, "Update"));

      // Update user car data based on active status
      if (newActiveStatus) {
        // Setting as active - update user profile with car details
        dispatch(updateUserCar(rowData.driver, {
          carType: rowData.carType,
          vehicleNumber: rowData.vehicleNumber,
          vehicleMake: rowData.vehicleMake,
          vehicleModel: rowData.vehicleModel,
          other_info: rowData.other_info,
          car_image: rowData.car_image,
          carApproved: rowData.approved,
          updateAt: new Date().getTime()
        }));
      } else {
        // Setting as inactive - clear user profile car details
        dispatch(updateUserCar(rowData.driver, {
          carType: null,
          vehicleNumber: null,
          vehicleMake: null,
          vehicleModel: null,
          other_info: null,
          car_image: null,
          carApproved: false,
          updateAt: new Date().getTime()
        }));
      }
    }
  };
  return carlistdata.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
    <ThemeProvider theme={theme}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label={t("approved")} />
          <Tab label={t("pending")} />
          <Tab label={t("declined")} />
        </Tabs>
      </Box>
      { getFilteredData()?.length >0 ? 
      <MaterialTable
        title={tabValue === 0 ? t("approved") : tabValue === 1 ? t("pending") : t("declined")}
        columns={getColumns()}
        onChangePage={(page)=>HandalePageChange(page)}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
          padding: "20px",
        }}
        data={getFilteredData()}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          initialPage:state?.pageNo,
          exportButton: true,
          actionsColumnIndex: tabValue === 2 ? -1 : undefined,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
          }),
          ...TableStyle()
        }}
        localization={localization(t)}
        editable={tabValue === 2 ? undefined : { 
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (oldData.active) {
                      reject();
                      alert(t("active_car_delete"));
                    } else {
                      resolve();
                      dispatch(editCar(oldData, "Delete"));
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        actions={[
          ...(tabValue === 2 ? [
            {
              icon: 'add',
              tooltip: t("add_car"),
              isFreeAction: true,
              onClick: (event) => navigate(`/cars/editcar`,{state:{pageNo:currentPage}})
            }
          ] : [
            {
              icon: 'add',
              tooltip: t("add_car"),
              isFreeAction: true,
              onClick: (event) => navigate(`/cars/editcar`,{state:{pageNo:currentPage}})
            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginRight:0
                  }}
                >
                  <EditIcon />  
                </div>
              ),
              onClick: (event, rowData) =>{
                navigate(`/cars/editcar/${rowData.id}`,{state:{pageNo:currentPage}})
              }
            }),
            ...(tabValue === 1 && role === "admin" && settings.carApproval ? [
              (rowData) => ({
                tooltip: t("decline"),
                icon: () => <BlockIcon style={{ color: colors.RED }} />,
                onClick: (event, rowData) => handleDeclineClick(rowData)
              })
            ] : [])
          ])
        ]}
      />
      : <BlankTable title={tabValue === 0 ? t("approved") : tabValue === 1 ? t("pending") : t("declined")} 
      actions={[
        {
          icon: 'add',
          tooltip: t("add_car"),
          isFreeAction: true,
          onClick: (event) => navigate(`/cars/editcar`)
        },
      ]}
      columns={getColumns()}  data={[]} localization={localization(t)} options={TableStyle()}/>}
    </ThemeProvider> 
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6" style={{ fontFamily: FONT_FAMILY }} >
            {t("upload_car_image")}
              <input
                type="file"
                style={{ marginLeft: 10, fontFamily: FONT_FAMILY }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip style={{ fontFamily: FONT_FAMILY }} title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: colors.RED,
                    borderRadius: 50,
                    color: colors.WHITE,
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  style={{ backgroundColor:colors.RED, fontFamily: FONT_FAMILY  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="secondaryButton"
                  style={{ marginLeft: 10 , backgroundColor:colors.GREEN, fontFamily: FONT_FAMILY  }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>

      <Dialog open={declineDialogOpen} onClose={handleDeclineCancel} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontFamily: FONT_FAMILY }}>{t('decline_car') || 'Decline Car'}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t('decline_reason') || 'Decline Reason'}
            type="text"
            fullWidth
            multiline
            rows={4}
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            placeholder={t('enter_decline_reason') || 'Enter reason for declining this car'}
            style={{ fontFamily: FONT_FAMILY }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeclineCancel} style={{ backgroundColor: colors.RED, fontFamily: FONT_FAMILY }}>
            {t('cancel')}
          </Button>
          <Button onClick={handleDeclineConfirm} style={{ backgroundColor: colors.GREEN, fontFamily: FONT_FAMILY }}>
            {t('submit')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
